module.exports = __webpack_public_path__ + "media/images/badges/yogasix/february/HeartBadges-26-89d49de5f5890676142fec6cd0ba5550.png";